import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta =
        installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/* ======================================================
   UPSELL – ADD TO CART (HORIZON COMPATIBLE)
====================================================== */

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-upsell-add');
  if (!btn) return;

  e.preventDefault();

  btn.disabled = true;
  btn.classList.add('is-loading');

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1
      })
    });

    if (!response.ok) throw new Error('Add to cart failed');

    const cart = await fetch('/cart.js').then((r) => r.json());

    document.dispatchEvent(
      new CartAddEvent({
        cart
      })
    );
  } catch (error) {
    console.error('Upsell add failed', error);
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }
});